export enum BusinessTypeEnum {
    Group = 'GROUP',
    Subgroup = 'SUBGROUP',
    Local = 'LOCAL'
}